// src/app/services/socialAuthService.ts
import { signInWithPopup, User as FirebaseUser } from 'firebase/auth';
import { agent } from '../api/agent';
import { SocialLoginData } from '../models/User';
import { auth, facebookProvider, googleProvider } from '../firebase/firebase-messaging';

export class SocialAuthService {
    async signInWithGoogle(): Promise<any> {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;
            
            // Get the ID token
            const idToken = await user.getIdToken();
            
            const socialLoginData: SocialLoginData = {
                idToken,
                provider: 'google',
                email: user.email || '',
                name: user.displayName || '',
                picture: user.photoURL || ''
            };

            // Send to your backend
            const response = await agent.Account.socialLogin(socialLoginData);
            return response;
        } catch (error) {
            console.error('Google sign-in error:', error);
            throw error;
        }
    }

    async signInWithFacebook(): Promise<any> {
        try {
            const result = await signInWithPopup(auth, facebookProvider);
            const user = result.user;
            
            // Get the ID token
            const idToken = await user.getIdToken();
            
            const socialLoginData: SocialLoginData = {
                idToken,
                provider: 'facebook',
                email: user.email || '',
                name: user.displayName || '',
                picture: user.photoURL || ''
            };

            // Send to your backend
            const response = await agent.Account.socialLogin(socialLoginData);
            return response;
        } catch (error) {
            console.error('Facebook sign-in error:', error);
            throw error;
        }
    }

    async signOut(): Promise<void> {
        try {
            await auth.signOut();
        } catch (error) {
            console.error('Sign-out error:', error);
            throw error;
        }
    }
}

export const socialAuthService = new SocialAuthService();